import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

const ColorButton = ({ selectedColor, disabled, buttonClassName, onOpen }) => {
  return (
    <div
      className={cn(
        'flex h-[40px] w-[88px] items-center justify-center gap-2 rounded-lg bg-white px-3',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        buttonClassName
      )}
      onClick={onOpen}>
      <div className="size-8 p-1">
        <div
          className={cn(
            'h-full rounded-full',
            selectedColor === '#ffffff' && 'border border-solid border-neutral-200'
          )}
          style={{ background: selectedColor }}
        />
      </div>
      <Icon icon="selector-linear" size={20} />
    </div>
  );
};

export default ColorButton;
